import React from 'react';
import ChatNow from '../ChatNow';

interface PipNewChatProps {
  isVisible: boolean;
}

const PipNewChat: React.FC<PipNewChatProps> = ({ isVisible }) => {
  return <ChatNow mode="pip" isVisible={isVisible} />;
};

export default PipNewChat;
